<template>
  <a @click.stop :href="url" target="_blank">
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: 'OpenLink',
  props: {
    href: {
      type: String,
      default: ''
    }
  },
  computed: {
    url () {
      if (this.href.startsWith('http://') || this.href.startsWith('https://')) {
        return this.href
      } else {
        return `${process.env.BASE_API}${this.href}`
      }
    }
  }
};
</script>
